<template>
  <div id="nav-user">
    <div id="navuser" class="navbar border-gradient">
      <b-navbar toggleable="lg" type="dark">
        <!-- Menu toggle -->
        <b-navbar-toggle target="nav-collapse">
          <b-icon
            v-if="expanded"
            icon="x"
            class="icone-toggle"
            :class="{ toggle2: isActive }"
            font-scale="2"
          ></b-icon>
          <b-icon
            v-else
            icon="list"
            class="icone-toggle"
            :class="{ toggle2: isActive }"
            font-scale="2"
          ></b-icon>
        </b-navbar-toggle>

        <b-collapse id="nav-collapse" is-nav>
          <b-navbar-brand
            id="Home"
            to="/"
            class="texto-menu nav-link nav-link-ltr"
          >
            <a href>
              <img class="arrow-nav" src="../assets/navbar-user/voltar.png" />
            </a>
            {{ "Voltar para o site" }}
          </b-navbar-brand>
          <b-navbar-nav class="ml-auto">
            <b-navbar-brand
              id="Palestras"
              to="/admin/palestras"
              class="texto-menu nav-link nav-link-ltr"
              v-if="verificaRota()"
              >{{ $t("Palestras") }}</b-navbar-brand
            >
            <b-navbar-brand
              id="Ao-vivo"
              to="/ao-vivo"
              class="texto-menu nav-link nav-link-ltr"
              v-else
            >
              {{ $t("Ao vivo") }}
              <img
                src="../assets/navbar-user/ao-vivo.png"
                class="imgSair d-inline-block"
                alt="ao vivo"
                to="/ao-vivo"
              />
            </b-navbar-brand>
            <b-navbar-brand
              id="Palestrantes"
              to="/admin/palestrantes"
              class="texto-menu nav-link nav-link-ltr"
              v-if="verificaRota()"
              >{{ $t("Palestrantes") }}</b-navbar-brand
            >
            <b-navbar-brand
              id="Palestras"
              to="/palestras"
              class="texto-menu nav-link nav-link-ltr"
              v-else
              >{{ $t("Palestras") }}</b-navbar-brand
            >
            <b-navbar-brand
              id="inscritos"
              to="/admin/usuarios"
              class="texto-menu nav-link nav-link-ltr"
              v-if="verificaRota()"
              >{{ $t("Inscritos") }}</b-navbar-brand
            >
            <b-navbar-brand
              id="perfil"
              to="/usuario/palestras-inscritas"
              class="texto-menu nav-link nav-link-ltr"
              v-else
              >{{ $t("Perfil") }}</b-navbar-brand
            >
            <b-navbar-brand
              id="sair"
              to="/"
              class="texto-menu nav-link nav-link-ltr"
              @click="logout"
            >
              {{ $t("Sair") }}
              <img
                src="../assets/navbar-user/sair.png"
                class="imgSair d-inline-block"
                alt="voltar"
                to="/"
                @click="logout"
              />
            </b-navbar-brand>
          </b-navbar-nav>
        </b-collapse>
      </b-navbar>
    </div>
  </div>
</template>

<script>
import { RemoveCookie } from "@/utils/CookieUtil";
export default {
  name: "Navbar",
  data() {
    return {
      isActive: false,
    };
  },
  methods: {
    logout() {
      RemoveCookie("token");
    },
    verificaRota() {
      // if (this.$route.path == "/admin/adicionar-palestrante" ||
      // this.$route.path == "/admin/adicionar-palestra" ||
      // this.$route.path == "/admin/usuarios" ||
      // this.$route.path == "/admin/palestras" ||
      // this.$route.path == "/admin/palestrantes" ||
      // this.$route.path == "/admin/inscritos/:idPalestra" || //not working yet
      // this.$route.path == "/admin/editar-palestra") //not working yet
      if (this.$route.meta.tipoNavbar == "navbarAdmin") {
        return true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#nav-user {
  .arrow-nav {
    height: 3.5vh;
    margin: 10px;
    padding-bottom: 1px;
  }
  .navbar {
    padding: 1.1em !important;
    top: 0;
    width: 100vw;
    position: fixed;
    display: flex;
    justify-content: flex-end;
    height: 8vh;
    z-index: 1000;
  }

  .border-gradient {
    text-align: center;
    padding-bottom: 5px;
    background: linear-gradient(to right, #ffc107, #ff0000) left bottom #100e17
      no-repeat;
    background-size: 100% 5px;
  }

  .navbar-dark .navbar-nav .nav-link {
    color: #ffffff;
  }

  .imgSair {
    height: 3vh;
    margin-left: 2px;
    padding-bottom: 3px;
  }

  .texto-menu {
    font-family: Roboto;
    font-size: 1em;
    font-weight: 500;
    color: #ffffff;
  }

  .rede-social-nav {
    cursor: pointer;
    padding-left: 0.2rem;
    padding-right: 0.8rem;
    height: 2.9vh;
    fill: #ff3b1c;
  }

  .nav-link {
    padding: 20px 0px;
    margin: 0px 20px;
    display: inline-block;
    position: relative;
    color: #ffffff;
  }

  .nav-link::before {
    transition: 300ms;
    height: 3px;
    content: "";
    position: absolute;
    background: linear-gradient(to right, #ff0000, #ffc107);
  }

  .nav-link-ltr::before {
    width: 0%;
    bottom: 15px;
  }

  .navbar-toggler {
    border: none;
  }

  .icone-toggle {
    color: #ff3b1c;
    display: flex;
    justify-content: center !important;
  }

  .toggle2 {
    color: #ffffff;
    display: flex;
    justify-content: center !important;
  }

  .menu2 {
    font-family: Roboto;
    font-size: 1em;
    font-weight: 500;
    color: #ffffff;
  }

  .link2::before {
    transition: 300ms;
    height: 3px;
    content: "";
    position: absolute;
    background: #ffffff;
  }

  .rede2 {
    cursor: pointer;
    height: 2.9vh;
    fill: #ffffff;
  }

  /* responsivo */
  @media screen and (max-width: 991px) {
    .navbar {
      padding: 0px !important;
      top: 0;
      width: 100vw;
      position: fixed;
      display: flex;
      justify-content: center;
    }

    .navbar-collapse {
      background: linear-gradient(to right, #ffc107, #ff0000);
      height: 50vh;
    }

    .navbar-brand {
      color: #ffffff !important;
      margin-left: 1.2rem;
    }

    .nav-link {
      padding: 0px 20px !important;
      margin: 15px 0px !important;
      text-align: left;
    }

    .nav-link-ltr:hover::before {
      width: auto;
    }

    .arrow-nav {
      height: 2.5vh;
      padding-bottom: 1px;
    }

    .texto-menu {
      font-family: Roboto;
      font-size: 1.2em;
      font-weight: 400;
    }

    .elemento-pai {
      display: flex;
      flex-direction: column;
    }

    .ordenando-elemento-nav {
      order: 1;
    }

    .ml-auto {
      margin-left: unset !important;
    }
  }
}
</style>

<style lang="scss">
.navbar-expand-lg {
  padding: 0px !important;
}
</style>
